module.exports = __webpack_public_path__ + "static/media/icon-dropdown-white.f5de03f6.svg";